import MembershipService from '@xo-union/sdk-membership';
import React, { createContext, useContext, useEffect, useState } from 'react';

import { ErrorContext } from './ErrorContext';

interface Default {
  member?: {
    id: string;
  };
}

interface Props {
  children: any;
}

export const MemberContext = createContext<Default>({
  member: undefined,
});

const membershipService = new MembershipService();

export const MemberProvider: React.FC<Props> = ({ children }) => {
  const [member, setMember] = useState(undefined);
  const { setErrors } = useContext(ErrorContext);

  useEffect(() => {
    const getMember = async (): Promise<void> => {
      try {
        const { data } = await membershipService.getMember();
        setMember(data.member);
      } catch (error) {
        setErrors();
      }
    };
    getMember();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <MemberContext.Provider value={{ member }}>{children}</MemberContext.Provider>;
};
